'use client';

import React from 'react';
import MenuItemCard from './MenuItemCard';

interface MenuItem {
  id: string;
  name: string;
  description: string;
  price: number;
  image: string;
  alt: string;
  category: string;
  isVeg: boolean;
  popularity: number;
}

interface MenuGridProps {
  items: MenuItem[];
  quantities: Record<string, number>;
  onQuantityChange: (itemId: string, quantity: number) => void;
  onAddToCart: (itemId: string) => void;
  hasActiveFilters?: boolean;
}

const MenuGrid = ({ items, quantities, onQuantityChange, onAddToCart, hasActiveFilters }: MenuGridProps) => {
  if (items.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <div className="text-6xl mb-4">🍽️</div>
        <h3 className="font-heading text-xl font-semibold text-foreground">
          {hasActiveFilters ? 'No items available for the selected city and filters.' : 'No items found'}
        </h3>
        <p className="mt-2 text-sm text-muted-foreground max-w-md">
          {hasActiveFilters
            ? 'Try changing the city, category, dietary preference, or Current Offer filter.'
            : 'Try adjusting your filters or browse other categories to find delicious dishes.'}
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {items.map((item) => (
        <MenuItemCard
          key={item.id}
          item={item}
          quantity={quantities[item.id] || 0}
          onQuantityChange={onQuantityChange}
          onAddToCart={onAddToCart}
        />
      ))}
    </div>
  );
};

export default MenuGrid;
